import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressInvitesApiAccountInvitesApiUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/invites-web',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
      {
        srcPath: '/invites',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/invites/invites/site',
        destPath: '/invites/site',
      },
      {
        srcPath: '/invites/invites/account',
        destPath: '/invites/account',
      },
      {
        srcPath: '/invites',
        destPath: '',
      },
      {
        srcPath: '/invites/site-invite',
        destPath: '/site-invite',
      },
      {
        srcPath: '/invites/account-invite',
        destPath: '/account-invite',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/invites-web',
        destPath: '',
      },
    ],
    'platform.rise.ai': [
      {
        srcPath: '/invites/site',
        destPath: '/invites/site',
      },
      {
        srcPath: '/site-invite',
        destPath: '/site-invite',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_user-management_account-invites';

/**
 * Creates and sends invite emails to a list of potential team members, inviting them to become team members of the requesting account.
 * The invites may be limited to a specific resource (site or other asset).
 * Maximum 50 invitees can be specified per call.
 *
 * > **Important**: This call requires an account level API key and cannot be authenticated with the standard authorization header. API keys are currently available to selected beta users only.
 */
export function createInvite(payload: object): RequestOptionsFactory<any> {
  function __createInvite({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.identity.invites.v1.account_invite',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.CreateInvite',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
        protoPath: '/account-invite/create',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'successfulInvites.dateCreated' },
              { path: 'successfulInvites.dateUpdated' },
              { path: 'successfulInvites.expirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createInvite;
}
